<div
	*ngIf="loading"
	class="flex align-items-center justify-content-center m-0 p-0"
>
	<p-progressSpinner></p-progressSpinner>
</div>



<!-- Modal recortador de imagen para creación-->
<p-dialog
	header="Recortador de imagen"
	[style]="{ width: '70vw' }"
	[(visible)]="croppedActive"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
>
	<div class="croppe">
		<image-cropper
			[imageChangedEvent]="imageChangedEvent"
			[maintainAspectRatio]="true"
			[aspectRatio]="1 / 1"
			resizeToHeight="512"
			format="jpeg"
			output="base64"
			(imageCropped)="imageCropped($event)"
			(imageLoaded)="imageLoaded($event)"
			(cropperReady)="cropperReady()"
			(loadImageFailed)="loadImageFailed()"
			class="cropper"
		></image-cropper>
	</div>
</p-dialog>

<div class="grid" *ngIf="!loading && user">
	<div class="col-12">
		<div class="card" style="background: transparent">
			<form [formGroup]="form">
				<input *ngIf="user.role_id != 4"
					type="hidden"
					formControlName="number_document"
					autocomplete="off" 
					pInputText
					class="d-none"
				/>
				<div class="container-img">
					<div class="custom-file-upload" *ngIf="stringPhoto">
						<img [src]="stringPhoto" style="width: 220px" alt="Foto cargada" />
						<button
							class="ml-2"
							type="button"
							pButton
							icon="pi pi-trash"
							(click)="deletePhoto()"
							*ngIf="stringPhoto"
						></button>
					</div>
					<div class="custom-file-upload">
						<input
							id="photoInputImage"
							type="file"
							(change)="handleUpload($event)"
							accept=".jpg,.png"
						/>
						<label class="btn-img">Selecciona imagen</label>
					</div>
				</div>

				<div class="grid p-fluid mt-3">
					<div class="field col-12 md:col-4">
						<label *ngIf=" user.role_id == 4">Razón social *</label>
						<label *ngIf=" user.role_id != 4">Nombre *</label>
						<input
							type="text"
							formControlName="name"
							pInputText
							class="w-full mb-3"
						/>
						<small
							class="p-error"
							*ngIf="
								form.get('name')!.errors &&
								form.get('name')!.touched &&
								form.get('name')!.hasError('required')
							"
							>Requerido</small
						>
						<small
							class="p-error"
							*ngIf="
								form.get('name')!.hasError('pattern') &&
								form.get('name')!.touched
							"
							>Introduzca solo letras</small
						>
					</div>
					<div class="field col-12 md:col-4">
						<label *ngIf=" user.role_id == 4">Contacto *</label>
						<label *ngIf=" user.role_id != 4">Apellidos *</label>
						<input
							type="text"
							formControlName="surname"
							pInputText
							class="w-full mb-3"
						/>
						<small
							class="p-error"
							*ngIf="
								form.get('surname')!.errors &&
								form.get('surname')!.touched &&
								form.get('surname')!.hasError('required')
							"
							>Requerido</small
						>
						<small
							class="p-error"
							*ngIf="
								form.get('surname')!.hasError('pattern') &&
								form.get('surname')!.touched
							"
							>Introduzca solo letras</small
						>
					</div>
					<div class="field col-12 md:col-4">
						<label>Email *</label>
						<input
							type="email"
							email
							formControlName="email"
							autocomplete="off" 
							pInputText
							class="w-full mb-3"
						/>
						<small
							class="p-error"
							*ngIf="
								form.get('email')!.errors &&
								form.get('email')!.touched &&
								form.get('email')!.hasError('required')
							"
							>Requerido</small
						>
						<small
							class="p-error"
							*ngIf="
								form.get('email')!.hasError('email') &&
								form.get('email')!.touched
							"
							>Formato incorrecto</small
						>
					</div>
					
					<div class="field col-12 md:col-4" *ngIf=" user.role_id == 4">
						<label>NIF *</label>
						<input
							type="text"
							formControlName="number_document"
							autocomplete="off" 
							pInputText
							class="w-full mb-3"
						/>
						<small
							class="p-error"
							*ngIf="
								form.get('number_document')!.errors &&
								form.get('number_document')!.touched &&
								form.get('number_document')!.hasError('required')
							"
							>Requerido</small
						>
					</div>
					<div class="field col-12 md:col-4">
						<label for="phone_number">Teléfono *</label>
						<input
							id="phone_number"
							type="text"
							maxlength="20"
							formControlName="phone_number"
							placeholder="+00 9999..."
							pInputText
							class="w-full mb-3"
						/>
						<small
							class="p-error"
							*ngIf="
								form.get('phone_number')!.errors &&
								form.get('phone_number')!.touched &&
								form.get('phone_number')!.hasError('required')
							"
							>Requerido</small
						>
						<small
							class="p-error"
							*ngIf="
								form.get('phone_number')!.hasError('pattern') &&
								form.get('phone_number')!.touched
							"
							>Introduzca valores numéricos</small
						>
					</div>

					<div class="field col-12 md:col-4">
						<label>Contraseña</label>
						<p-password 
						autocomplete="new-password" 
						formControlName="password" 
						[toggleMask]="true"></p-password>
					</div>
					<div class="field col-12 md:col-4">
						<label for="password_confirmation"
							>Confirmación de contraseña</label
						>
						<p-password 
						autocomplete="new-password" 
						formControlName="password_confirmation" 
						[toggleMask]="true"></p-password>
						<small
							class="p-error"
							*ngIf="
								form.get('password_confirmation')!.errors &&
								form.get('password_confirmation')!.touched &&
								form.get('password_confirmation')!.hasError('required')
							"
							>Requerido
						</small>
						<small
							class="p-error"
							*ngIf="
								form.get('password_confirmation')!.errors &&
								form.get('password_confirmation')!.touched
							"
							>Contraseña y confirmación de contraseña no coinciden</small
						>
					</div>

					<div class="flex justify-content-end col-12">
						<p-button
							styleClass="p-button-primary p-button-rounded"
							label="Actualizar datos"
							(click)=" (user.role_id === 1 || user.role_id === 4) ? handleConfirmUpdate() : saveUser()"
						>
						</p-button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

<p-dialog
	header="Actualización de datos de usuario"
	[(visible)]="confirmUpdateDialog"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '30vw' }"
>
	<div class="grid p-fluid mt-3">
		<div class="form-container">
			<div class="field col-12" *ngIf="user">
				Está intentando actualizar sus datos de usuario administrador por los
				siguientes:
				<ol>
					<li><strong>Email: </strong>{{ newEmail }}</li>
					<li><strong *ngIf="user.role_id == 4">Razón social: </strong> <strong *ngIf="user.role_id != 4">Nombre: </strong>{{ newName }}</li>
					<li><strong *ngIf="user.role_id == 4">Contacto: </strong> <strong *ngIf="user.role_id != 4">Apellidos: </strong>{{ newSurname }}</li>
					<li *ngIf="user.role_id == 4"><strong>NIF: </strong>{{ newNumberDocument }}</li>
				</ol>
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<p-button
			styleClass="p-button-rounded mt-4"
			label="Confirmar datos"
			(click)="saveUser()"
			[loading]="loading"
		>
		</p-button>
	</ng-template>
</p-dialog>
